import { format, isToday, isYesterday } from "date-fns";
import { ar, enUS, es, it } from "date-fns/locale";
import type { TFunction } from "i18next";

const localeMap: Record<string, Locale> = {
  es,
  en: enUS,
  it,
  ar,
};

type Locale = typeof enUS;

/**
 * Notification timestamp formatter used by the profile bottom-sheet and the
 * notifications page. Mirrors the design reference: "Hoy · 18:13",
 * "Ayer · 17:30", "12 jun · 08:00". Purely presentational — falls back to the
 * Spanish locale (the app default) for languages without a date-fns locale.
 */
export function formatNotificationTime(
  dateString: string | null,
  lang: string,
  t: TFunction,
): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";

  const locale = localeMap[lang?.split("-")[0]] ?? es;
  const time = format(date, "HH:mm", { locale });

  if (isToday(date)) return `${t("notifications.time.today", "Hoy")} · ${time}`;
  if (isYesterday(date)) return `${t("notifications.time.yesterday", "Ayer")} · ${time}`;
  return `${format(date, "d MMM", { locale })} · ${time}`;
}
